import React, { useContext, useEffect, useRef, useState } from 'react'
import { Content, FilterDiv, FilterImg, FilterText } from './style'
import { LeftSide, RightSide, SectionName, SubHeaderContainer, Tab, TabsDiv, ButtonCreate } from '../../../components/styles/subheader-style'
import orders from '../../../assets/fashion/TableFashionHeader/orders.svg'
import clock from '../../../assets/fashion/TableFashionHeader/clock.svg'
import filter from '../../../assets/stock/TableMovementHeader/filter.svg'
import diskIcon from '../../../assets/addStockModal/pages/disk.svg'
import { Outlet, useNavigate, useOutletContext, useLocation, useParams } from 'react-router-dom'
import { TypeMainOutlet } from '..'

// Adicione sua tipagem de produto aqui
interface ProductType {
  id: number
  name: string
  quantity: number
  // ...outros campos
}

export interface FashionOutletType {
  tabIndex: number
  setTabIndex: React.Dispatch<React.SetStateAction<number>>
  addedProducts: ProductType[]
  setAddedProducts: React.Dispatch<React.SetStateAction<ProductType[]>>
  handleSave: React.MutableRefObject<() => void>
  handleEditSave: React.MutableRefObject<() => void>
  search?: string
}

const tabs = [
  { path: '', image: orders, name: 'Pedidos' },
  { path: 'pre-programming', image: clock, name: 'Pré programação' },
]

const FashionSubHeader: React.FC<{
  tabIndexActived: number
  isCreating: boolean
  isEditing: boolean
  onSave?: () => void
  onEditSave?: () => void
}> = ({ tabIndexActived, isCreating, isEditing, onSave, onEditSave }) => {
  const navigate = useNavigate()
  const { orderId } = useParams()

  return (
    <SubHeaderContainer>
      <LeftSide>
        <SectionName>
          {isCreating
            ? 'Novo pedido: 123456'
            : isEditing
            ? `Editar pedido: ${orderId}`
            : 'Pedidos fashion'}
        </SectionName>
        {!isCreating && !isEditing && (
          <TabsDiv>
            {tabs.map((tab, index) => (
              <Tab
                key={index}
                $isFirst={index === 0}
                $isLast={index === tabs.length - 1}
                $isActive={index === tabIndexActived}
                onClick={() => {
                  if (index !== tabIndexActived) navigate(tab.path)
                }}
              >
                <img src={tab.image} alt={`${tab.path}-icon`} />
                {tab.name}
              </Tab>
            ))}
          </TabsDiv>
        )}
      </LeftSide>
      <RightSide>
        {!isCreating && !isEditing && (
          <FilterDiv>
            <FilterImg src={filter} alt='filter-icon' />
            <FilterText>Filtrar</FilterText>
          </FilterDiv>
        )}
        <ButtonCreate
          onClick={() => {
            const pathname = window.location.pathname
            const isCreating = pathname.includes('/panel/fashion/create')
            const isEditing = pathname.includes('/panel/fashion/edit/')

            if (isCreating && onSave) {
              onSave()
              navigate('/panel/fashion', { replace: true })
            } else if (isEditing && onEditSave) {
              onEditSave()
              navigate('/panel/fashion', { replace: true })
            } else {
              navigate('/panel/fashion/create')
            }
          }}
        >
          {isCreating || isEditing ? (
            <>
              <img src={diskIcon} />
              Salvar pedido
            </>
          ) : (
            '+ Novo pedido'
          )}
        </ButtonCreate>
      </RightSide>
    </SubHeaderContainer>
  )
}

const FashionContent = () => {
  const [tabIndex, setTabIndex] = useState<number>(0)
  const [addedProducts, setAddedProducts] = useState<ProductType[]>(() => {
    // Recupera do sessionStorage ao carregar
    const saved = sessionStorage.getItem('addedProducts')
    return saved ? JSON.parse(saved) : []
  })

  const { search } = useOutletContext<TypeMainOutlet>()
  const location = useLocation()
  const navigate = useNavigate()

  const isCreating = location.pathname.includes('/panel/fashion/create')
  const isEditing = location.pathname.startsWith('/panel/fashion/edit/')

  const handleSave = useRef<() => void>(() => {
    console.log('POST executado')
    console.log('Produtos:', addedProducts)
  })

  const handleEditSave = useRef<() => void>(() => {
    console.log('PUT executado')
  })

  // Atualiza sessionStorage sempre que addedProducts mudar
  useEffect(() => {
    sessionStorage.setItem('addedProducts', JSON.stringify(addedProducts))
  }, [addedProducts])

  return (
    <>
      <FashionSubHeader
        tabIndexActived={tabIndex}
        isCreating={isCreating}
        isEditing={isEditing}
        onSave={() => handleSave.current()}
        onEditSave={() => handleEditSave.current()}
      />
      <Content>
        <Outlet
          context={{
            tabIndex,
            setTabIndex,
            addedProducts,
            setAddedProducts,
            handleSave,
            handleEditSave,
            search,
          }}
        />
      </Content>
    </>
  )
}

export default FashionContent
